module.exports = __webpack_public_path__ + "static/img/tradingcalculator.b93025f.svg";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/tradingcalculator.svg
// module id = xqLU
// module chunks = 4